import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=16ef307d&scoped=true"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=16ef307d&prod&lang=scss&scoped=true"
import style1 from "./AccountForm.vue?vue&type=style&index=1&id=16ef307d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef307d",
  null
  
)

export default component.exports